import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { LocationContextService } from '../../../../client/app/location-context/location-context.service';
import { ConfirmationDialogComponent } from '../../../../client/app/shared/confirmation-dialog/confirmation-dialog.component';
import { IErrorLog } from '../../../../model/error-logs';
import { ILocationContext } from '../../../../model/location-context';
import { ErrorLogDetailDialogComponent } from '../error-log-detail-dialog/error-log-detail-dialog.component';
import { ErrorLogsService } from '../error-logs.service';

@Component({
    selector: 'app-error-logs',
    templateUrl: './error-logs.component.html',
    styleUrls: ['./error-logs.component.scss']
})
export class ErrorLogsComponent implements OnInit, OnDestroy {
    sub: Subscription;
    loading: boolean;

    displayedColumns: string[] = ['dateString', 'errorType'];
    dataSource = new MatTableDataSource<IErrorLog>();
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    nodataFound = false;

    locationContext: ILocationContext;

    constructor(
        private readonly errorLogsService: ErrorLogsService,
        private readonly locationContextService: LocationContextService,
        public dialog: MatDialog
    ) {}

    ngOnInit() {
        this.loading = true;

        // Get location context
        this.locationContext = this.locationContextService.getLocationContext();

        // Request data
        this.errorLogsService.requestErrorLogs(this.locationContext);

        // Load data
        this.sub = this.errorLogsService.getErrorLogs().subscribe(errorLogs => {
            this.loading = false;

            this.dataSource = new MatTableDataSource<IErrorLog>(errorLogs);
            this.nodataFound = this.dataSource.data.length === 0;

            if (this.paginator) {
                this.paginator.length = errorLogs.length;
                this.dataSource.paginator = this.paginator;
            }

            this.dataSource.sort = this.sort;
        });
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    confirmClearLogs() {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: 'Are you sure you want to clear the error logs?'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                // eslint-disable-next-line no-console
                console.log('Clear Logs...');
            }
        });
    }

    showDetail(errorLog: IErrorLog) {
        this.dialog.open(ErrorLogDetailDialogComponent, {
            data: errorLog
        });
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
